import { render, staticRenderFns } from "./FeaturedArticlesModule.vue?vue&type=template&id=0a39080c&"
import script from "./FeaturedArticlesModule.ts?vue&type=script&lang=ts&"
export * from "./FeaturedArticlesModule.ts?vue&type=script&lang=ts&"
import style0 from "./FeaturedArticlesModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports